import React from 'react'
import { Icon, IconProps } from './Icon'

export function FastForward(props: Omit<IconProps, 'children'>) {
  return (
    <Icon {...props}>
      <path d="M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z"/>
      <path d="M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z"/>
    </Icon>
  )
}
